import Tag from 'components/generic/tag';
import { ColorBeauty4, ColorNeutralBlack } from 'autogen/design-tokens/tokens';
import { ArticleHeaderFromContextProps } from '../shared/types';

export default function Label({
    label,
    ...restProps
}: {
    label: Exclude<ArticleHeaderFromContextProps['label'], undefined>;
}) {
    return (
        <Tag backgroundColor={ColorBeauty4} textColor={ColorNeutralBlack} size="md" {...restProps}>
            {label}
        </Tag>
    );
}
